import React from 'react';
import { Page } from 'components';
import { useBreakpoint } from 'hooks';

import MyBrokerageSearch from './MyBrokerageSearch';
import ListingsSearchOptions from './ListingsSearchOptions';

const MyBrokerageLayout: React.FC = ({ children }) => {
  const { md, xl } = useBreakpoint();

  return (
    <Page
      title={md ? 'My Brokerage' : ''}
      type="filled"
      headerExtra={<MyBrokerageSearch />}
      headerVerticalAlign={xl ? 'center' : 'baseline'}
    >
      <ListingsSearchOptions />
      {children}
    </Page>
  );
};

export default MyBrokerageLayout;
